<template>

    <section v-if="product && order">

        <section class="container">

            <header class="container__header">

                <h1>Opret bestilling</h1>

            </header>

            <section class="container__body container__body--xlg">

                <section class="col-12">

                    <router-link :to="{name:'make-order'}">Tilbage</router-link>

                </section>

                <section class="row margin-t-50">

                    <article class="wrap--product">

                        <section class="product">

                            <section class="img margin-b-25">

                                <img :srcset="sourceSet" :src="'/storage/images/' + product.image" :alt="product.title">

                            </section>

                            <section class="content">

                                <h1>{{product.title}}</h1>

                                <nl2br tag="p" :text="product.description"></nl2br>

                                <h3>Pris pr. stk.</h3>

                                <h4>{{stripeAmount(product.price).amount}},-</h4>

                                <ul>
                                    <li><i class="icon--md fas fa-info-circle"></i> Minimumsbestilling er {{product.min_quantity}} stk.</li>
                                    <li v-if="product.category_exceptions !== null && product.category_exceptions.hasOwnProperty('newyears') && product.category_exceptions.newyears"><i class="icon--md fas fa-info-circle"></i> Kan bestilles indtil d. 27 dec. / indtil udsolgt </li>
                                    <li v-else><i class="icon--md fas fa-info-circle"></i> Kan bestilles indtil dagen før kl. 12.00 / indtil udsolgt</li>
                                    <li><i class="icon--md fas fa-info-circle"></i> Alle retter afhentes / afleveres kolde</li>
                                </ul>

                                <section class="col-12 margin-t-25">

                                    <incrementer v-model="quantity" :min="product.min_quantity" increase="quantityIncrease" decrease="quantityDecrease"></incrementer>

                                </section>

                            </section>

                        </section>

                    </article>

                </section>

                <section class="row">

                    <selection-item v-for="selection in product.selections" :selection="selection" :key="selection.id"></selection-item>

                </section>

                <section class="row">

                    <section class="addons" v-for="selection in product.extra_selections">

                        <article class="wrap--product">

                            <header class="addons__header border-b padding-b-25 margin-b-50">

                                <h1>Tilkøb - {{selection.title}} </h1>

                            </header>

                            <main class="addons__items">

                                <option-item v-for="option in selection.options" :option="option" :selection="selection" :as-extra="true" :key="option.id" :start-quantity="getExtraOptionStartQuantity(selection, option)"></option-item>

                            </main>

                        </article>

                    </section>

                </section>

                <total></total>

            </section>

        </section>

    </section>

</template>

<script>
    import {mapGetters} from 'vuex';
    import PlusMinusNumberInput from './partials/PlusMinusNumberInput.vue';
    import Option from './partials/option.vue';
    import Selection from './partials/selection.vue';
    import Total from './partials/total.vue';
    import moment from 'moment';

    export default {
        name: "CustomProduct",
        components:{
            'incrementer':PlusMinusNumberInput,
            'option-item':Option,
            'selection-item':Selection,
            Total
        },
        computed:{
            ...mapGetters({
                product:'product',
                order:'order',
            }),
            quantity:{
                get(){
                    return this.order.details.quantity;
                },
                set(value){
                    this.$store.dispatch('setQuantity', value);
                }
            },
            sourceSet(){
                return '/storage/images/' + this.product.image_x1 + ' 1x, ' + '/storage/images/' + this.product.image + ' 2x';
            },
            orderDate(){
                return moment().endOf('year').subtract(1, 'days');
            }
        },
        watch:{
            product(value){
                this.setupFlow(value);
            },
        },
        methods:{
            setupFlow(value){
                this.$store.dispatch('setOrderProduct', value);
                this.$store.dispatch('setQuantity', value.min_quantity);
                this.$store.dispatch('setCustomSelections', value.selections);
                this.$store.dispatch('setCustomExtraSelections', value.extra_selections);
            },
            getExtraOptionStartQuantity(selection, option){
                const extraSelection = this.order.details.extra_selections.find(item => {
                    return item.extra_selection_id === selection.id;
                });

                let optionData = null;

                if(extraSelection && extraSelection.options){
                     optionData = extraSelection.options.find(item => item.id === option.id);
                }

                if(!optionData){
                    return 0;
                }

                return optionData.quantity;
            }
        }
    }
</script>

<style scoped>

</style>
